module.exports = __webpack_public_path__ + "img/CheckBoxold.8739434f.svg";